"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const VideoPlayer_1 = __importDefault(require("../../../common/components/Other/VideoPlayer"));
const ItemImage = styled_components_1.default.div `
  width: 100%;
  flex-basis: 100%;
  img {
    display: block;
    width: 100%;
  }
  @media (min-width: 1024px) and (orientation: landscape) {
    flex-basis: 50%;
    height: 100%;
    order: 2;
    img {
      height: 100%;
      object-fit: cover;
    }
  }
`;
const ItemVideo = styled_components_1.default.div `
  background: radial-gradient(50% 94%, #4c4c4c 0%, #858585 94%);
  height: 100vw;
  @media (min-width: 1024px) and (orientation: landscape) {
    flex-basis: 50%;
    height: 100%;
    order: 2;
  }
`;
const ItemMedia = ({ activeItem, forwardedRef = null }) => {
    const { content } = activeItem;
    const renderImage = () => (react_1.default.createElement(ItemImage, { className: "item-detail-image", ref: forwardedRef },
        react_1.default.createElement("picture", null,
            react_1.default.createElement("source", { media: "(max-width: 1023px)", srcSet: content.primaryImage }),
            react_1.default.createElement("source", { media: "(min-width: 1024px)", srcSet: content.largeImage }),
            react_1.default.createElement("img", { src: "/images/other/placeholder.png", alt: content.title }))));
    if (content.videos && content.videos.length > 0) {
        const video = content.videos[0];
        try {
            const videoUrl = new URL(video.value);
            if (videoUrl.host === "bcove.video") {
                return react_1.default.createElement(react_1.default.Fragment, null, renderImage());
            }
            return (react_1.default.createElement(ItemVideo, null,
                react_1.default.createElement(VideoPlayer_1.default, { video: video, autoplay: false, muted: false })));
        }
        catch (e) {
            return react_1.default.createElement(react_1.default.Fragment, null, renderImage());
        }
    }
    return react_1.default.createElement(react_1.default.Fragment, null, renderImage());
};
exports.default = ItemMedia;
